export default __webpack_public_path__ + "static/media/sao-paulo.c443cded.png";